<template>
    <div class="card mt-5 row">
        <div class="card-header bg-primary text-white">
            <div class="card-title h5 m-0">
                {{ isEnVersion ? page.labelEn : page.label }}
            </div>
        </div>
        <div class="card-body row ml-0">
            <div class="col-md-6">
                <h5 class="ml-1">{{ $t('dynamicLayout.panelsVisible') }}</h5>
                <div @drop="onDrop">
                    <draggable v-model="page.settings" class="row col-12 dragArea maxHeight"
                        @start="draggableDragStart" @end="draggableDragEnd" animation="150">
                            <component
                                        v-for="(panel, index) in page.settings"
                                        :key="index"
                                        :is="panel.name"
                                        :panel="panel">
                            </component>
                    </draggable>
                </div>
            </div>
            <div class="col-md-6">
                <h5 class="ml-2" v-if="!dragging">{{ $t('dynamicLayout.eligiblePanels') }}</h5>
                <div v-if="!dragging" class="dragArea dragAreaEligiblePanels">
                    <draggable v-model="eligiblePanelsData" class="row col-12 maxHeight ml-0" animation="150">
                        <component class="dropitem eligiblePanels"
                                   v-for="(panel, index) in eligiblePanelsData"
                                   :key="index"
                                   :is="panel.name"
                                   :panel="panel">
                        </component>
                    </draggable>
                </div>
                <div class="trashzoneContainer" v-if="dragging" @drop="onDropInTrashZone">
                    <draggable v-model="trashZone" class="dropzone trashzone sticky-top" :options="trashOptions">
                        <div class="card sticky-bottom" v-bind:style="{ height: trashZoneHeight + 'px'}">
                            <div class="card-header bg-danger text-white">
                                <div class="card-title h5 m-0">{{ $t('dynamicLayout.removeFromPage') }}</div>
                            </div>
                            <div class="card-body text-center py-5">
                                <i class="fa fa-trash-alt fa-9x text-danger"></i>
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Culture } from '@/models/enums';
    import Draggable from 'vuedraggable';
    import EventsMap from '../dynamicLayout/panels/EventsMap';
    import MyLastParticipations from '../dynamicLayout/panels/MyLastParticipations';
    import MyForms from '../dynamicLayout/panels/MyForms';
    import MyLastActionLogs from '../dynamicLayout/panels/MyLastActionLogs';
    import LearningActivity from '../dynamicLayout/panels/LearningActivity';
    import OtherActivities from '../dynamicLayout/panels/OtherActivities';
    import UpcomingEvents from '../dynamicLayout/panels/UpcomingEvents';
    import PendingConfirmation from '../dynamicLayout/panels/PendingConfirmation';
    import ConfirmationsList from '../dynamicLayout/panels/ConfirmationsList';
    import { DynamicLayoutPanelModel } from '@/models/models';

export default {
    props: {
        page: Object,
    },
    components: {
        Draggable,
        EventsMap,
        MyLastParticipations,
        MyForms,
        MyLastActionLogs,
        LearningActivity,
        OtherActivities,
        UpcomingEvents,
        PendingConfirmation,
        ConfirmationsList
    },
    data() {
        return {
            dragging: false,
            trashZone: [],
            trashOptions: {
                group: {
                    name: 'trash',
                    draggable: '.dropitem',
                    put: () => true,
                    pull: false
                }
            },
            eligiblePanelsData: this.markAsEligiblePanels(this.page.eligiblePanels),
            trashZoneHeight: 0
        }
    },
    methods: {
        draggableDragStart() {
            this.dragging = true;
        },
        draggableDragEnd() {
            this.dragging = false;
        },
        onDrop(event) {
            let innerText = event.dataTransfer.getData("Panel");
            let droppedPanel = this.eligiblePanelsData.find(panel => panel.label === innerText || panel.labelEn === innerText);
            let panelAlreadyVisible = this.page.settings.find(panel => panel.label === innerText || panel.labelEn === innerText);
            if (!panelAlreadyVisible) {
                this.page.settings.push(new DynamicLayoutPanelModel({
                    name: droppedPanel.name,
                    label: droppedPanel.label,
                    labelEn: droppedPanel.labelEn,
                    sort: this.page.settings.length + 1,
                    size: 6
                }));
            };
        },
        onDropInTrashZone(event) {
            this.resetSort();
        },
        resetSort() {
            let index = 0;
            this.page.settings.forEach(panel => {
                this.page.settings.splice(index, 1, new DynamicLayoutPanelModel({
                    name: panel.name,
                    label: panel.label,
                    labelEn: panel.labelEn,
                    sort: index,
                    size: panel.size
                }));
                index++;
            });
        },
        markAsEligiblePanels(panels) {
            panels.map((panel) => { panel.isEligiblePanel = true });
            return panels;
        }
    },
    computed: {
        isEnVersion() {
            return this.$store.getters.currentCulture === Culture.EN;
        }
    },
    mounted() {
        this.trashZoneHeight = document.getElementsByClassName('dragAreaEligiblePanels')[0].offsetHeight;
    }
}
</script>

<style scoped>
    .dragArea {
        background: #ccc;
        min-height: 100px;
    }
    .trashzone .dropitem {
        display: none;
    }
    .ml-0 {
        margin-left: 0;
    }
    .ml-1 {
        margin-left: -11px!important;
    }
    .ml-2 {
        margin-left: 4px!important;
    }
    .trashzoneContainer {
        margin-top: 32px;
    }
</style>
